import { Link } from "react-router-dom";
import { Globe2, Palette, Zap } from "lucide-react";
import { useSite } from "../context/SiteContext";
import { imgUrl } from "../lib/api";

const FEATURES = [
  [Zap, "Fast Turnaround", "Custom apparel and print projects handled quickly without sacrificing quality."],
  [Palette, "Custom Branding", "Logos, apparel, business cards, window graphics, stickers, and more."],
  [Globe2, "Local & Beyond", "Serving Cincinnati customers and custom print orders beyond the local area."],
];

export default function About() {
  const { settings: s = {} } = useSite();
  return (
    <div className="pb-20">
      <section className="mx-auto grid max-w-7xl items-center gap-12 px-6 pt-16 lg:grid-cols-2">
        <img src={imgUrl(s.about_image)} alt="ASAP & Co. owners and customers wearing custom apparel" className="rise w-full rounded-2xl border border-white/10" data-testid="about-image" />
        <div className="rise" style={{ animationDelay: ".2s" }}>
          <span className="chip">About ASAP & Co.</span>
          <h1 className="outline-title mt-5 text-5xl sm:text-6xl" data-testid="about-title">ASAP & Co.</h1>
          <p className="mt-2 font-display text-2xl font-bold uppercase text-[#E5202A]">Custom Print Group</p>
          <p className="mt-5 text-base font-semibold text-white md:text-lg">{s.about_intro}</p>
        </div>
      </section>
      <section className="mx-auto mt-16 max-w-4xl px-6">
        <h2 className="red-title text-3xl md:text-4xl">{s.about_title}</h2>
        <div className="mt-6 space-y-5 leading-relaxed text-slate-300" data-testid="about-body">
          {(s.about_body || "").split(/\n\s*\n/).map((p, i) => <p key={i}>{p}</p>)}
        </div>
      </section>
      <section className="mx-auto mt-14 grid max-w-6xl gap-5 px-6 md:grid-cols-3">
        {FEATURES.map(([Icon, t, d]) => (
          <div key={t} className="panel p-7 transition-transform duration-300 hover:-translate-y-1">
            <Icon className="h-9 w-9 text-[#E5202A]" />
            <h3 className="mt-3 font-display text-2xl font-bold uppercase">{t}</h3>
            <p className="mt-2 text-sm text-slate-400">{d}</p>
          </div>
        ))}
      </section>
      <div className="mt-14 text-center"><Link to="/order" className="btn-red" data-testid="about-start-order-button">Start Custom Order</Link></div>
    </div>
  );
}
